import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 relative overflow-hidden" data-id="element-153">
      {/* Background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-gradient-to-b from-trading-gold/5 to-transparent pointer-events-none" data-id="element-154" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-155">
        <div className="max-w-3xl mx-auto text-center" data-id="element-156">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-trading-card border-2 border-trading-gold/30 rounded-2xl p-8 md:p-12 shadow-[0_0_50px_rgba(212,168,67,0.1)] relative" data-id="element-157">
            {/* Badge */}
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-trading-gold to-trading-amber text-trading-dark font-bold font-heading px-6 py-2 rounded-full text-sm tracking-wider uppercase shadow-lg" data-id="element-158">
              Oferta Especial
            </div>

            <h2 className="text-3xl md:text-4xl font-heading text-white mb-6 mt-4" data-id="element-159">
              Estrategia Probada para Pasar Pruebas de Fondeo en el NASDAQ
            </h2>

            <p className="text-slate-300 mb-8 max-w-xl mx-auto" data-id="element-160">
              No pagues cientos de dólares por mentorías vacías. Obtén el
              protocolo operativo por solo una fracción del costo de un reset de
              cuenta.
            </p>

            <div className="mb-10" data-id="element-161">
              <span className="text-slate-400 line-through text-xl mr-3" data-id="element-162">
                $45 USD
              </span>
              <span className="text-5xl md:text-6xl font-heading font-bold text-gradient-gold" data-id="element-163">
                $9.99 USD
              </span>
            </div>

            <Button fullWidth href="https://impactoproactivo.com/cart/40925420453952:1" className="text-xl py-5 shadow-[0_0_30px_rgba(212,168,67,0.3)] mb-6" data-id="element-164">
              ¡QUIERO MI ESTRATEGIA PARA PASAR CUENTAS AHORA!
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-slate-400" data-id="element-165">
              <div className="flex items-center gap-2" data-id="element-166">
                <LockIcon className="w-4 h-4 text-trading-gold" data-id="element-167" />
                <span data-id="element-168">Pago 100% Seguro</span>
              </div>
              <div className="hidden sm:block w-1 h-1 bg-slate-600 rounded-full" data-id="element-169"></div>
              <div className="flex items-center gap-2" data-id="element-170">
                <ShieldCheckIcon className="w-4 h-4 text-trading-gold" data-id="element-171" />
                <span data-id="element-172">Acceso Inmediato PDF</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}